import { fetchMailFolders } from "@/lib/api/imap";
import { INBOX_BOOTSTRAP_FOLDER_GAP_MS } from "@/lib/constants/inbox";

type FetchParams = Parameters<typeof fetchMailFolders>[0];

let chain: Promise<unknown> = Promise.resolve();

function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}

/** Une requête folders.php à la fois — évite « Too many simultaneous connections » (Gmail/OVH). */
export function fetchMailFoldersQueued(params?: FetchParams) {
  const run = chain.then(async () => {
    await sleep(INBOX_BOOTSTRAP_FOLDER_GAP_MS);
    return fetchMailFolders(params);
  });
  chain = run.then(
    () => undefined,
    () => undefined
  );
  return run;
}

/** Séquentiel avec pause entre comptes / appels badges. */
export async function fetchMailFoldersSequential(
  jobs: Array<{ accountId: number; refresh?: boolean; badges?: boolean }>
) {
  const results: Awaited<ReturnType<typeof fetchMailFolders>>[] = [];
  for (const job of jobs) {
    results.push(await fetchMailFoldersQueued(job));
  }
  return results;
}
